import $ from 'jquery';
import 'wizard';

import 'fuelux.css'

var defaults = {
  ctx: '',
  submit_on_complete: true,
  enableAll: false,
  focusOnFirst: true,
  disable_submit_on_enter: true,
  navigationButtons: true,
  elem: null,
  buttonSanitizer: null,
}

var submit = function (D) {
  var form = $('form', D.elem)
  if (form.length !== 0) {
    D.enableAll = false
    $('.actions button.btn-next', D.elem)
      .prop('disabled', true)
      .addClass('to-be-reenabled')
    $('.down-actions button.down-btn-next', D.elem)
      .prop('disabled', true)
      .addClass('to-be-reenabled')
    form.submit()
  } else {
    console.error('could not find a form here')
  }
}

var focusOnFirst = function (D) {
  $('.step-pane.active input:first', D.elem).data('step')
}

var updateForStep = function (D, step) {
  var totalSteps = $('.steps li', D.elem).length
  var e = $('.actions button.btn-next', D.elem)
  var es = $('.actions button.btn-submit', D.elem)
  if (e.length == 0 && es.length == 1) {
    e = es
  }
  var ed = $('.down-actions button.down-btn-next', D.elem)
  var eds = $('.down-actions button.down-btn-submit', D.elem)
  if (ed.length == 0 && eds.length == 1) {
    ed = eds
  }

  if (step == 1) {
    $('.down-actions button.down-btn-prev', D.elem).attr('disabled', 'disabled')
  } else {
    $('.down-actions button.down-btn-prev', D.elem).removeAttr('disabled')
  }

  if (step == totalSteps) {
    turnIntoLast(D, e)
    turnIntoLast(D, ed)
    turnClassesIntoLast(ed)
    turnClassesIntoLast(e)
  } else {
    turnIntoNotLast(D, e)
    turnIntoNotLast(D, ed)
    turnClassesIntoNotLast(ed)
    turnClassesIntoNotLast(e)
  }
}

var refreshState = function (D) {
  console.log('sorcier::refreshState')
  var steps = $('.steps li', D.elem)

  steps.each(function () {
    var e = $(this)

    if (e.hasClass('lastone')) {
      return false
    }
    if (enableAll && !e.hasClass('active')) {
      e.addClass('complete')
    }
    e.find('span.badge').addClass('badge-success')
    var i = e.data('step')

    console.log('sorcier::treating step=' + i)
    if (D.elem.find('[data-step="' + i + '"] .has-error').length !== 0) {
      console.log('sorcier::found errors at ' + i)
      e.addClass('has-error')
    } else {
      console.log('sorcier::no errors found at ' + i)
      e.removeClass('has-error')
    }
  })
}

var turnClassesIntoLast = function (but) {
  if (!but.data('last-text')) {
    return
  }
  if (but.hasClass('down-btn-next')) {
    but.removeClass('down-btn-next')
    but.addClass('down-btn-submit')
  } else if (but.hasClass('btn-next')) {
    but.removeClass('btn-next')
    but.addClass('btn-submit')
  }
}

var turnClassesIntoNotLast = function (but) {
  if (!but.data('last-text')) {
    return
  }
  if (but.hasClass('down-btn-submit')) {
    but.removeClass('down-btn-submit')
    but.addClass('down-btn-next')
  } else if (but.hasClass('btn-submit')) {
    but.removeClass('btn-submit')
    but.addClass('btn-next')
  }
}

var turnIntoLast = function (D, but) {
  var last = but.data('last-text')
  if (last) {
    if (D.buttonSanitizer) {
      last = D.buttonSanitizer(last)
    }
    but.data('saved-button', but.html())
    but.html(last)
  }
}

var turnIntoNotLast = function (D, but) {
  var sbut = but.data('saved-button')
  if (sbut) {
    if (D.buttonSanitizer) {
      sbut = D.buttonSanitizer(sbut)
    }
    but.html(sbut)
    but.data('saved-button', null)
  }
}

var enableAll = function (D) {
  D.enableAll = true
}

var currentStep = function (D) {
  return $('li.active', D.elem).data('step')
}

var removeFocus = function (D) {
  $('.actions button', D.elem).blur()
}

export default {
  init: function (opts) {
    var D = $.extend({}, defaults, opts || {})

    console.log('sorcier::init', D)
    if (D.elem === null || D.elem === '') {
      console.error('Sorcier::elem cannot be null', D)
      return
    }
    if (typeof D.elem === 'string') {
      D.elem = $(D.elem)
    }
    if (D.elem.length === 0) {
      console.error('Sorcier::elem does not exist', D)
      return
    }
    if (D.elem.data('enable-all')) {
      console.log('sorcier::enable all set by data')
      D.enableAll = true
    }

    D.w = D.elem.wizard()

    if (D.submit_on_complete) {
      D.w.on('finished.fu.wizard', function () {
        submit(D)
      })
    }

    $('.actions button.btn-next', D.elem).click(function (evt, data) {
      evt.preventDefault()
      removeFocus(D)
    })

    $('.actions button.btn-prev', D.elem).click(function (evt, data) {
      evt.preventDefault()
      removeFocus(D)
    })

    $('.down-actions button.down-btn-next', D.elem).click(function (evt, data) {
      D.elem.wizard('next')
      evt.preventDefault()
      removeFocus(D)
    })

    $('.down-actions button.down-btn-prev', D.elem).click(function (evt, data) {
      D.elem.wizard('previous')
      evt.preventDefault()
      removeFocus(D)
    })

    D.w.on('actionclicked.fu.wizard', function (evt, data) {
      if (data.direction != 'next') {
        return
      }
      if ($('.steps li:nth-child(' + data.step + ')', D.elem).hasClass('lastone')) {
        console.log('sorcier::just clicked the last one')
        evt.preventDefault()
        submit(D)
      }
    })

    D.w.on('changed.fu.wizard', function (evt, data) {
      updateForStep(D, data.step)
    })

    if (D.focusOnFirst) {
      focusOnFirst(D)
    }

    if (D.disable_submit_on_enter) {
      $('input', D.elem).keydown(function (event) {
        if (event.which == 13) {
          var t = $(this)

          var needEnter = t.hasClass('need-enter')

          console.log('sorcier::do I need to handle enter: ' + t)
          if (needEnter) {
            return true
          }
          event.preventDefault()
          var ninput = $('input', t.parent().next())

          if (ninput.length !== 0) {
            ninput.first().focus()
          } else {
            D.w.wizard('next')
          }
          return false
        }
      })
    }

    D.w.on('changed.fu.wizard', function (e, data) {
      refreshState(D)
    })

    var prev = $('.actions button.btn-prev', D.elem)
    var prevDown = $('.down-actions button.down-btn-prev', D.elem)

    var next = $('.actions button.btn-next', D.elem)
    var nextDown = $('.down-actions button.down-btn-next', D.elem)

    if (prev.length === 0 &&
      next.length === 0 &&
      prevDown.length === 0 &&
      nextDown.length === 0) {
      D.navigationButtons = false
    }

    if (D.navigationButtons == false) {
      console.log('sorcier::no navigation buttons selected')
      prev.hide()
      prevDown.hide()
      next.hide()
      nextDown.hide()
      var c = $('.actions button.btn-submit', D.elem)
      c.removeClass('hidden')
      var cd = $('.down-actions button.down-btn-submit', D.elem)
      cd.removeClass('hidden')
      if (D.submit_on_complete) {
        c.click(function (e) {
          submit(D)
          e.preventDefault()
        })
        cd.click(function (e) {
          submit(D)
          e.preventDefault()
        })
      }
    }

    var curStep = currentStep(D)
    if (curStep == 1) {
      $('.down-actions button.down-btn-prev', D.elem).prop('disabled', true)
    }

    updateForStep(D, curStep)
    refreshState(D)
    return {
      enableAll: function () {
        enableAll(D)
      },
      refresh: function () {
        refreshState(D)
      },
      gotoError: function () {
        var err = D.elem.find('li.has-error')

        if (err.length !== 0) {
          var c = err.first().data('step')

          console.log('sorcier::found first error at position ' + c)
          D.w.wizard('selectedItem', {
            step: c,
          })
        }
      },
    }
  },
}
